export default __webpack_public_path__ + "static/media/300.209840d0.jpg";